import {Module} from 'virtual-tour-viewer/src/modules/React360Proxy';
import TourActions from '../data/Tour/TourActions';

export default class UIOverlayModule extends Module {
    constructor() {
        super('UIOverlayModule');
    }

    /**
     * This module should have a method that will take props from a "NativeModules.UIOverlayModule.function(props)" call.
     * This function will update the overlay.
     *
     * This function should be called by a proxy component that is detached from the scene, but on render or on receiving props
     * (check the React-360 component documentation for options) forwards them to this module.
     *
     * The TourMenu components will need to be reactjs only, no react-360 components. This call back will still execute in the UI (main) thread
     * and will not have access to react native. That means that the UI container will need to be removed as will the UI view so that this module
     * renders a TourMenu directly and that TourMenu must use <div>...</div> instead of <View>...</View>.
     */

    update(props, tourActionType) {
        // TODO: Replace this module with the use of the Observable State Module.
        TourActions.setAppState(props.state);
    }
}
